
export default {
  emits: ['close']
}
